import {
    makeSelectWrapper,
    NumberCol,
    RenderStringCol,
    SelectCol,
    Table,
    ViewOnly
} from "../../../../misc/scroller/Table";
import {api} from "../../../../api/API";
import {useProjectId, useProjectUnitSystem} from "../../shopdrawing/ProjectName";
import {DoorCore} from "../../../../api/Openings";
import React, {useContext} from "react";
import {useIsQuote} from "../QuoteContainer";
import {useAlternative} from "../alternative/Alternative";
import {DropDownContext, useDropdownData} from "../../settings/DropDowns";
import {CircularProgress} from "@mui/material";
import {FileCol} from "../../settings/FileCol";

export function ReviewDoorCore() {
    const project = useProjectId();
    const sys = useProjectUnitSystem();
    const isQuote = useIsQuote();
    const alt = useAlternative();

    const ddl = useContext(DropDownContext);
    const doorCoreOptions = useDropdownData(ddl.doorCores);

    if(ddl.loading || !sys) {
        return <CircularProgress />
    }

    return (
        <Table<DoorCore>
            name={"door-cores"}
            fetch={ctx => {
                return isQuote ? api.quoteOpenings.listDoorCores({
                        project: project,
                        alternative: alt,
                    }) : api.openings.listDoorCores({
                        project: project,
                    });
            }}
            fetchDeps={[project, alt, isQuote]}
            columns={[
                SelectCol<DoorCore>("Door Core", "doorCore", makeSelectWrapper(doorCoreOptions)),
                ViewOnly(NumberCol("Qty", "count")),
                FileCol<DoorCore>("Attachment", "doorCoreFile", "doorCoreFileName"),
                RenderStringCol("-", () => ""),
            ]}
            onChange={input => {
                if(isQuote) {
                    return api.quoteOpenings.upsertDoorCore(input);
                }

                return api.openings.upsertDoorCore(input);
            }}
        />
    )
}